import { render } from "./IconEditorCmp.vue?vue&type=template&id=7c9cbde4"
import script from "./IconEditorCmp.vue?vue&type=script&lang=js"
export * from "./IconEditorCmp.vue?vue&type=script&lang=js"

import "./IconEditorCmp.vue?vue&type=style&index=0&id=7c9cbde4&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__